// extracted by mini-css-extract-plugin
export var active = "_lw-2";
export var recordingDot = "_lw-1";
export var recordingIndicator = "_lw-0";